import React from 'react';
import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { formulaLabelsConfig } from '../Formula/Formula.labels.config';
import './FormulaInput.scss';

interface IFormulaInput {
  k: string;
  valid: boolean;
  value: any;
  onChange: (event: {}) => void;
  onBlur?: (event: { target: any }) => void;
  formula?: string;
}

const makeInputUnitsGeneric = (key, formulaName: string | undefined) => {
  if (formulaName !== undefined && key.specifyFor !== undefined && key.specifyFor.includes(formulaName)) {
    return (key.label as string).replace(key.replace, key.specificUnits).trim();
  }
  else return key.label;
}

export const FormulaInput = observer(({ k, valid, value, onChange, onBlur, formula }: IFormulaInput) => {
  const label = formulaLabelsConfig[k] ? makeInputUnitsGeneric(formulaLabelsConfig[k], formula) : k;

  if (formulaLabelsConfig[k] && formulaLabelsConfig[k].hidden) {
    return <></>;
  } else if (formulaLabelsConfig[k] && formulaLabelsConfig[k].options) {
    // select
    return (
      <ComboBox
        idAndName={k}
        label={label}
        aria-label={label}
        valid={true}
        value={value}
        onChange={onChange}
        // onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
        options={formulaLabelsConfig[k].options}
        errorMsg={''}
        required={formulaLabelsConfig[k].required}
        className={valid ? '' : ' usa-input--error'}
      />
    );

    // checkbox
  } else if (formulaLabelsConfig[k] && formulaLabelsConfig[k].checkbox) {
    return (
      <div className="common-input-container">
        <label className="label-formula-checkbox usa-label" htmlFor={k}>
          {label}
        </label>
        <div className="pt-1 pl-2">
          <input id={k} data-testid="the-Checkbox" type="checkbox" name={k} onChange={onChange} />
        </div>
      </div>
    );
  } else {
    // numeric input
    return (
      <Input
        required={formulaLabelsConfig[k] && formulaLabelsConfig[k].required}
        key={`form-field-${k}`}
        label={label}
        idAndName={k}
        valid={valid}
        value={value}
        type="number"
        onChange={onChange}
        onBlur={onBlur}
        // errorMsg={valid ? '' : formulaLabelsConfig[k].errorMsg}
        step={formulaLabelsConfig[k] && formulaLabelsConfig[k].step ? formulaLabelsConfig[k].step : 0.01}
        min={0}
        // max={1}
        // onBlur={vm.validateInput}
        onKeyDown={handleOnKeyDown}
        className={valid ? '' : ' usa-input--error'}
      />
    );
  }
});
function handleOnKeyDown(event) {
  ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
}

interface IRadioGroup {
  label?: string;
  labelId: string;
  items: IRadioItem[];
  labelClassName?: string;
}

interface IRadioItem {
  label?: string;
  id: string;
  name: string;
  className?: string;
  onChange: (event: {}) => void;
  disabled?: boolean;
  checked: boolean;
}

export const FormulaRadioGroup = observer((props: IRadioGroup) => {
  return (
    <div>
      <fieldset className="usa-fieldset">
        {props.label ? (
          <legend className={`usa-label ${props.labelClassName ? props.labelClassName : ''}`} id={props.labelId}>
            {props.label}
          </legend>
        ) : null}

        {props.items.map((el, i) => (
          <div className="usa-radio" key={'group' + i}>
            <input
              className={'usa-radio__input ' + el.className}
              id={el.id}
              key={el.id + i}
              data-testid={'the-RadioGroup-' + i}
              aria-describedby={props.labelId}
              type="radio"
              name={el.name}
              checked={el.checked}
              onChange={el.onChange}
              disabled={el.disabled}
            />
            <label className="usa-radio__label" htmlFor={el.id} key={'label' + el.id + i}>
              {el.label}
            </label>
          </div>
        ))}
      </fieldset>
    </div>
  );
});
